import { Stack } from '@mui/material';
import { BasicTabs } from '@/components/shared/BasicTabs';
import { FloatingLine } from '@/components/ZonesManagementRevamped/styles';
import { useCallback, useMemo, useState } from 'react';
import { ZoneHistory } from './ZoneHistory';
import { auditTabStyles } from './styles';

export const ZoneAudit = () => {
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const changeTab = useCallback((tabIndex: number) => {
    setSelectedTabIndex(tabIndex);
  }, []);

  const tabs = useMemo(() => {
    return [
      {
        label: 'History',
        component: <ZoneHistory />,
      },
      {
        label: 'Time tracking',
        component: <p>Time tracking</p>,
      },
    ].map((tab, index) => ({ ...tab, index }));
  }, []);

  return (
    <Stack>
      <BasicTabs
        renderingStrategy="eager"
        tabs={tabs}
        selectedTab={selectedTabIndex}
        changeTab={changeTab}
        tabsStyles={auditTabStyles}
        customSeperator={<FloatingLine />}
      />
    </Stack>
  );
};
